import l from "dayjs";
import M from "dayjs/plugin/utc.js";
import d from "dayjs/plugin/timezone.js";
import g from "dayjs/plugin/advancedFormat.js";
var h = /* @__PURE__ */ ((e) => (e.Yes = "yes", e.No = "no", e.PreferNotToSay = "prefer not to say", e))(h || {}), b = /* @__PURE__ */ ((e) => (e.Yes = "yes", e.No = "no", e.Open = "open", e.Undecided = "undecided", e.PreferNotToSay = "prefer not to say", e))(b || {}), w = /* @__PURE__ */ ((e) => (e.No = "No", e.TryinToQuit = "TryinToQuit", e.SocialSmoker = "SocialSmoker", e.Yes = "Yes", e))(w || {}), N = /* @__PURE__ */ ((e) => (e.Never = "Never", e.Sober = "Sober", e.Occasionally = "Occasionally", e.Weekly = "Weekly", e.MostNights = "MostNights", e))(N || {}), S = /* @__PURE__ */ ((e) => (e.Yes = "Yes", e.Occasionally = "Occasionally", e.Never = "Never", e))(S || {}), P = /* @__PURE__ */ ((e) => (e.Yes = "Yes", e.Occasionally = "Occasionally", e.Never = "Never", e))(P || {}), D = /* @__PURE__ */ ((e) => (e.Groupme = "Groupme", e.Email = "Email", e.Phone = "Phone", e))(D || {}), k = /* @__PURE__ */ ((e) => (e.administrative_area_level_1 = "administrative_area_level_1", e.administrative_area_level_2 = "administrative_area_level_2", e.administrative_area_level_3 = "administrative_area_level_3", e.administrative_area_level_4 = "administrative_area_level_4", e.administrative_area_level_5 = "administrative_area_level_5", e.archipelago = "archipelago", e.colloquial_area = "colloquial_area", e.continent = "continent", e.country = "country", e.establishment = "establishment", e.finance = "finance", e.floor = "floor", e.food = "food", e.general_contractor = "general_contractor", e.geocode = "geocode", e.health = "health", e.intersection = "intersection", e.landmark = "landmark", e.locality = "locality", e.natural_feature = "natural_feature", e.neighborhood = "neighborhood", e.place_of_worship = "place_of_worship", e.plus_code = "plus_code", e.point_of_interest = "point_of_interest", e.political = "political", e.post_box = "post_box", e.postal_code = "postal_code", e.postal_code_prefix = "postal_code_prefix", e.postal_code_suffix = "postal_code_suffix", e.postal_town = "postal_town", e.premise = "premise", e.room = "room", e.route = "route", e.street_address = "street_address", e.street_number = "street_number", e.sublocality = "sublocality", e.sublocality_level_1 = "sublocality_level_1", e.sublocality_level_2 = "sublocality_level_2", e.sublocality_level_3 = "sublocality_level_3", e.sublocality_level_4 = "sublocality_level_4", e.sublocality_level_5 = "sublocality_level_5", e.subpremise = "subpremise", e.town_square = "town_square", e))(k || {});
function f(e, r) {
  return typeof r == "object" && r !== null && r.dataType === "Map" ? new Map(r.value) : r;
}
function O(e, r) {
  return r instanceof Map ? {
    dataType: "Map",
    value: Array.from(r.entries())
    // or with spread: value: [...value]
  } : r;
}
const R = (e, r) => {
  const a = JSON.parse(e, f), t = JSON.parse(r, f);
  for (const [i, o] of t || /* @__PURE__ */ new Map())
    if (!a.has(i))
      a.set(i, o);
    else {
      const s = a.get(i);
      o.completed && (s.completed = !0);
      for (const [_, n] of o.sections || /* @__PURE__ */ new Map())
        if (s.sections || (s.sections = /* @__PURE__ */ new Map()), !s.sections.has(_))
          s.sections.set(_, n);
        else {
          const c = (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            s.sections.get(_)
          );
          n.completed && (c.completed = !0), c.videoStats = n.videoStats, n.private ? c.private = !0 : delete c.private;
          for (const [v, m] of n.questions || /* @__PURE__ */ new Map())
            c.questions || (c.questions = /* @__PURE__ */ new Map()), c.questions.set(v, m);
          s.sections.set(_, c);
        }
      a.set(i, s);
    }
  return JSON.stringify(a, O);
}, z = [
  "Agender",
  "Androgyne",
  "Androgynous",
  "Bigender",
  "Female to male",
  "FTM",
  "Intersex",
  "Male to female",
  "Man",
  "MTF",
  "Neither",
  "Neutrois",
  "Non-binary",
  "Other",
  "Pangender",
  "Queer",
  "Trans",
  "Trans man",
  "Trans person",
  "Trans woman",
  "Transgender",
  "Transgender female",
  "Transgender male",
  "Transgender man",
  "Transgender person",
  "Transgender woman",
  "Transfeminine",
  "Transmasculine",
  "Two spirit",
  "Vakasalewalewa",
  "Woman"
], Q = [
  "Agnostic",
  "Atheist",
  "Buddhist",
  "Catholic",
  "Christian",
  "Hindu",
  "Jewish",
  "Muslim",
  "Spiritual",
  "Prefer not to say"
];
var x = /* @__PURE__ */ ((e) => (e.Password = "Password", e.ThirdParty = "ThirdParty", e.SessionToken = "SessionToken", e.PriveledgedToken = "PrivilegedToken", e.ReadableToken = "ReadableToken", e))(x || {});
const Y = {
  Body: "ProfilePictureBody",
  Headshot: "ProfilePictureHeadshot",
  Action: "ProfilePictureAction",
  Friends: "ProfilePictureFriends",
  Travel: "ProfilePictureTravel",
  Pet: "ProfilePicturePet"
}, V = {
  ...Y
};
var $ = /* @__PURE__ */ ((e) => (e.OppositeGender = "opposite gender", e.MenDatingMen = "men dating men", e.WomenDatingWomen = "women dating women", e.NonBinary = "non binary", e))($ || {}), q = /* @__PURE__ */ ((e) => (e.Admin = "admin", e))(q || {}), y = /* @__PURE__ */ ((e) => (e.Visa = "Visa", e.MasterCard = "MasterCard", e.AmericanExpress = "AmericanExpress", e.Discover = "Discover", e))(y || {});
const W = {
  Monday: 0,
  Tuesday: 1,
  Wednesday: 2,
  Thursday: 3,
  Friday: 4,
  Saturday: 5,
  Sunday: 6
};
var B = /* @__PURE__ */ ((e) => (e.Spark = "Spark", e.NoSpark = "NoSpark", e.DidNotAttend = "DidNotAttend", e.Unmatched = "Unmatched", e.Declined = "Declined", e))(B || {});
l.extend(M);
l.extend(d);
const u = "America/New_York", U = (e = void 0, r) => {
  const a = l(e).tz(u), t = a.startOf("week").add(4, "day");
  let i = t.add(a.isBefore(t) ? 1 : 2, "week").startOf("week").add(1, "day");
  if (r) {
    const o = l(r.date).tz(u).startOf("week").add(1, "day");
    i.isBefore(o) && (i = o);
  }
  return i;
};
l.extend(g);
const Z = (e, r) => {
  let a = l(e), t = l(r);
  if (t < a) {
    const o = a;
    a = t, t = o;
  }
  let i = "";
  return a.isSame(t, "day") ? (i = a.format("dddd, MMM D") + " ", a.format("a") === t.format("a") ? i += `${a.format("h:mm")} - ${t.format("h:mma")}` : i += `${a.format("h:mma")} - ${t.format("h:mma")}`) : i = `${a.format("dddd, MMM D h:mma")} - ${t.format(
    "dddd, MMM D h:mma"
  )}`, i;
}, G = (e, r) => {
  let a = l(e), t = l(r);
  if (t < a) {
    const o = a;
    a = t, t = o;
  }
  let i = "";
  return a.isSame(t, "month") ? i = `${a.format("MMM D")} - ${t.format("D")}` : i = `${a.format("MMM D")} - ${t.format("MMM D")}`, i;
}, H = "America/New_York", L = 7, X = 5242880, j = [
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term"
];
export {
  k as AddressComponentType,
  D as ContactPreferenceEnum,
  x as CredentialType,
  y as CreditCardType,
  W as DayOfWeekOffset,
  N as DrinkingEnum,
  P as DrugsEnum,
  q as GroupType,
  h as HaveChildrenEnum,
  X as MAX_MEDIA_BYTES,
  S as MarajuanaEnum,
  V as MediaKey,
  Y as ProfilePictureKey,
  L as SPARK_FEEDBACK_DEADLINE_DAYS,
  w as SmokingEnum,
  $ as SparkGenderType,
  j as UTM_KEYS,
  B as UserRelationshipType,
  b as WantChildrenEnum,
  z as commonGenders,
  Q as commonReligions,
  H as etZone,
  G as getDateRangeString,
  Z as getDateTimeRangeString,
  U as getMondayForSpark,
  R as mergeProfile,
  O as profileReplacer,
  f as profileReviver
};
